import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
} from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

interface EnterpriseInfoModalProps
  extends Omit<ModalProps, 'onClose' | 'children'> {
  onClose: () => void
}

export const EnterpriseInfoModal = ({
  onClose,
  ...rest
}: EnterpriseInfoModalProps) => {
  const { t } = useTranslation('common')

  return (
    <Modal blockScrollOnMount isCentered onClose={onClose} {...rest}>
      <ModalOverlay overflow="hidden" />
      <ModalContent maxW="400px">
        <ModalHeader fontFamily="Proxima Nova Semibold" fontSize="18px">
          {t('TRANSLATION_226')}
        </ModalHeader>
        <ModalCloseButton />
        <Divider />
        <ModalBody p="24px">
          <Text w="full" fontSize="16px">
            {t('TRANSLATION_227')}
          </Text>
          <Button mt="32px" h="52px" onClick={onClose}>
            {t('CONFIRM_LABEL')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
